import { apiUrls } from '../../constants';
import { getCurrentLocale } from './cookies';

export const getSupportUrl = (): string => {
  // Picking first 2 chars of locale for support site
  const language = getCurrentLocale().toLowerCase()?.split('_')[0];
  return apiUrls.SUPPORT_FAQ_URL.replace('{language}', `${language}`);
};
